import React, { useState, useMemo } from "react";
import { Redirect, useHistory } from "react-router-dom";
import axios from "axios";
import moment from "moment";
import DataTable from "react-data-table-component";
import { NotificationManager } from "react-notifications";
import { makeStyles } from "@mui/styles";
import LinearProgress from "@mui/material/LinearProgress";

import Tooltip from "@mui/material/Tooltip";
import VisibilityIcon from "@mui/icons-material/Visibility";

import styles from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.js";
import { deleteActionPlan } from "services/ConfigServices";
import { statusData } from "variables/lists/planActions";
import usePlandactionsTable from "./usePlandactionsTable.js";
import CustomDeleteDialog from "../CustomDeleteDialog/CustomDeleteDialog.js";
import CustomDeleteButton from "../CustomDeleteButton/CustomDeleteButton.js";
import CustomCommentDialog from "../CustomCommentDialog/CustomCommentDialog.js";
import SelectedPlanActions from "./SelectedPlanActions.js";
import UserService from "../../services/UserService";
//import "react-table/react-table.css";
import {
  Navigate,
} from "react-router-dom";
// @mui/icons-material
import GetAppIcon from "@mui/icons-material/GetApp";

import Button from "components/CustomButtons/Button.js";

const useStyles = makeStyles(styles);

const RTPlanActions = (props) => {
  const permis = JSON.parse(localStorage.getItem("permission")) || [];
  const actionplanadmin = permis.includes("actionplan_admin");
  const { gridState, error, refetch, invalidate } = props;

  const [redirState, setRedirState] = useState(false);
  const [planActionId, setPlanActionId] = useState("");
  const [planActionName, setPlanActionName] = useState("");
  let redirecting = redirState && (
    <Navigate
      push
      to={{
        pathname: "/admin/actionplans/selectedplanaction/",
        state: { planActionId, planActionName },
      }}
      state= {{ planActionId, planActionName }}
    />
  );

  let dataPlanActions = gridState.data;

  const classes = useStyles();
  
  if (error) {
    return (
      <p>
        <span role="img" aria-label="Problem">
          🔧
        </span>{" "}
        Oups il semble y avoir un problème...{" "}
        <button onClick={refetch}>Réesayer</button>
      </p>
    );
  }

  const columns = [
    {
      name: "Code/clé",
      selector: (row) => row.parameters.code,
      sortable: true,
      maxWidth: "7rem",
    },
    {
      name: "Nom",
      selector: (row) => row.parameters.name,
      sortable: true,
      mixWidth: "15rem",
    },
    {
      name: "statut",
      sortable: true,
      maxWidth: "12rem",
      cell: (row) =>
        row.parameters.status == "creation" ? (
          <div style={{ color: "#849191", fontWeight: "bold" }}>
            {statusData.find((x) => x.id == "creation").name}
          </div>
        ) : row.parameters.status == "pending" ? (
          <div style={{ color: "#E3A322", fontWeight: "bold" }}>
            {statusData.find((x) => x.id == "pending").name}
          </div>
        ) : row.parameters.status == "inprogress" ? (
          <div style={{ color: "#008083", fontWeight: "bold" }}>
            {statusData.find((x) => x.id == "inprogress").name}
          </div>
        ) : row.parameters.status == "standby" ? (
          <div style={{ color: "#FF8E55", fontWeight: "bold" }}>
            {statusData.find((x) => x.id == "standby").name}
          </div>
        ) : row.parameters.status == "finished" ? (
          <div style={{ color: "#91C73C", fontWeight: "bold" }}>
            {statusData.find((x) => x.id == "finished").name}
          </div>
        ) : (
          <div style={{ color: "#FF432D", fontWeight: "bold" }}></div>
        ),
    },
    {
      name: "Date de début prévue",
      sortable: true,
      maxWidth: "12rem",
      cell: (row) =>
        moment(row.parameters.prevstartdate).isValid()
          ? moment(row.parameters.prevstartdate).format("DD/MM/YYYY")
          : "",
    },
    {
      name: "Date de fin prévue",
      sortable: true,
      maxWidth: "12rem",
      cell: (row) =>
        moment(row.parameters.prevenddate).isValid()
          ? moment(row.parameters.prevenddate).format("DD/MM/YYYY")
          : "",
    },
    {
      name: "Priorités",
      selector: (row) => row.parameters.priority,
      sortable: true,
      width: "7rem",
    },
    {
      name: "",
      sortable: false,
      width: "7rem",
      // eslint-disable-next-line react/button-has-type
      // eslint-disable-next-line react/display-name
      cell: (row) => (
        <>
          <div className="actions-right">
            <Tooltip title="Voir les détails du plan d'action">
              <Button
                onClick={PADetail(row)}
                color={"info"}
                className={classes.actionButton}
              >
                <VisibilityIcon fontSize="large" />
              </Button>
            </Tooltip>
            {actionplanadmin && (
              <CustomDeleteButton
                deleteTitle={"Suppression plan d'action"}
                deleteSubTitle={`Êtes-vous sûr de vouloir supprimer ${row.parameters.name} ?`}
                handleSupprimer={deletePA(row)}
              />
            )}
          </div>
        </>
      ),
    },
  ];

  const PADetail = (row) => async () => {
    setPlanActionId(row.id);
    setPlanActionName(row.parameters.name);
    setRedirState(true);
  };

  const deletePA = (row) => async () => {
    let obj = dataPlanActions.find((o) => o.id === row.id);
    let idSelected = obj.id;
   // console.log(idSelected);
    let url = deleteActionPlan(idSelected);
    axios
      .delete(url, {
        headers: {
          Authorization: `Bearer ${UserService.getToken()}`,
        },
      })
      .then((res) => {
        console.log(res);
        if (res.status == 200) {
          setNotification(
            "success",
            `Le plan d'action ${obj.parameters.name} a été supprimé`
          );
          refetch();
        } else setNotification("error", "Une erreur est survenue");
      })
      .catch((error) => {
        setNotification("error", "Une erreur est survenue");
      });
  };

  const setNotification = (status, text) => {
    if (status === "success") {
      NotificationManager.success(text);
    } else {
      NotificationManager.error(text);
    }
  };

  return (
    <>
      <DataTable
          paginationRowsPerPageOptions={[10,20,30,50,100]}
        noHeader={true}
        columns={columns}
        persistTableHead
        pagination
        subHeader
        progressPending={gridState.loading}
        progressComponent={<LinearProgress />}
        highlightOnHover
        pointerOnHover
        onRowClicked={(row) => {
          setPlanActionId(row.id);
          setPlanActionName(row.parameters.name);
          setRedirState(true);
        }}
        paginationComponentOptions={{
          noRowsPerPage: false,
          rowsPerPageText: "Lignes par page",
          rangeSeparatorText: "sur",
          selectAllRowsItem: false,
          selectAllRowsItemText: "Selectionner toutes les lignes",
        }}
        {...gridState}
      />
      {redirecting}
    </>
  );
};

export default RTPlanActions;
